export const Logo = () => {
  return (
    <div style={{ height: "2rem", width: "2rem" }}>
      <img src="/images/Small Logo.svg" alt="Small Logo" />
    </div>
  );
};
